import React, { useEffect, useState } from "react";
import { IBannerData, INewsLetterData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useLoader } from "../context/LoaderContext";
import {
  fetchNewsLetterBanner,
  fetchNewsLetterData,
} from "../api/NewsLetterApi";
import NewsLetterBanner from "../components/newsLetter/NewsLetterBanner";
import AllNewsLetter from "../components/newsLetter/AllNewsLetter";

const NewsLetter = () => {
  const { setLoading } = useLoader();
  const [newsLetterData, setNewsLetterData] = useState<INewsLetterData[]>([]);
  const [newsLetterBannerData, setNewsLetterBannerData] = useState<
    IBannerData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchNewsLetterBanner(), fetchNewsLetterData()])
      .then(([newsLetterBannerData, newsLetterData]) => {
        setNewsLetterBannerData(newsLetterBannerData);
        setNewsLetterData(newsLetterData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <NewsLetterBanner newsLetterBannerData={newsLetterBannerData} />
      <AllNewsLetter newsLetterData={newsLetterData}/>
    </>
  );
};

export default NewsLetter;
